"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useRovingTabIndexContext;

var _react = require("react");

var _Context = _interopRequireDefault(require("./Context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRovingTabIndexContext() {
  var throwOnUndefined = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var contextValue = (0, _react.useContext)(_Context.default);

  if (throwOnUndefined && !contextValue) {
    throw new Error('botframework-webchat internal: This hook can only be used under <RovingTabIndexComposer>.');
  }

  return contextValue;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VSb3ZpbmdUYWJJbmRleENvbnRleHQiLCJ0aHJvd09uVW5kZWZpbmVkIiwiY29udGV4dFZhbHVlIiwidXNlQ29udGV4dCIsIlJvdmluZ1RhYkluZGV4Q29udGV4dCIsIkVycm9yIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcHJvdmlkZXJzL1JvdmluZ1RhYkluZGV4L3ByaXZhdGUvdXNlQ29udGV4dC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VDb250ZXh0IH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgUm92aW5nVGFiSW5kZXhDb250ZXh0IGZyb20gJy4vQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVJvdmluZ1RhYkluZGV4Q29udGV4dCh0aHJvd09uVW5kZWZpbmVkID0gdHJ1ZSkge1xuICBjb25zdCBjb250ZXh0VmFsdWUgPSB1c2VDb250ZXh0KFJvdmluZ1RhYkluZGV4Q29udGV4dCk7XG5cbiAgaWYgKHRocm93T25VbmRlZmluZWQgJiYgIWNvbnRleHRWYWx1ZSkge1xuICAgIHRocm93IG5ldyBFcnJvcignYm90ZnJhbWV3b3JrLXdlYmNoYXQgaW50ZXJuYWw6IFRoaXMgaG9vayBjYW4gb25seSBiZSB1c2VkIHVuZGVyIDxSb3ZpbmdUYWJJbmRleENvbXBvc2VyPi4nKTtcbiAgfVxuXG4gIHJldHVybiBjb250ZXh0VmFsdWU7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFFQTs7OztBQUVlLFNBQVNBLHdCQUFULEdBQTJEO0VBQUEsSUFBekJDLGdCQUF5Qix1RUFBTixJQUFNO0VBQ3hFLElBQU1DLFlBQVksR0FBRyxJQUFBQyxpQkFBQSxFQUFXQyxnQkFBWCxDQUFyQjs7RUFFQSxJQUFJSCxnQkFBZ0IsSUFBSSxDQUFDQyxZQUF6QixFQUF1QztJQUNyQyxNQUFNLElBQUlHLEtBQUosQ0FBVSwyRkFBVixDQUFOO0VBQ0Q7O0VBRUQsT0FBT0gsWUFBUDtBQUNEIn0=